import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Slide from "@mui/material/Slide";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import { THEME_VARIANT } from ".";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const MuiModalWindow = (props) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  const handleClose = () => {
    if (props.onClose) props.onClose();
  };

  return (
    <>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        PaperProps={{
          sx: {
            backgroundColor: "#f1f1f1", // Change to your desired color
          },
        }}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            {props.title && (
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                {props.title}
              </Typography>
            )}
            {/*<Button autoFocus color="inherit" onClick={handleClose}>
              save
            </Button>*/}
          </Toolbar>
        </AppBar>
        <DialogContent sx={{ padding: "10px" }}>{props.children}</DialogContent>
      </Dialog>
    </>
  );
};

export default MuiModalWindow;
